var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{class:_vm.is_android15 ? _vm.isLogged ? 'safe-top-bar' :'safe-top-bar-login' :''}),(_vm.isLogged)?_c('default-layout'):_c('login-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }